(() => {
  if (window.whCartEnhancements) return;
  window.whCartEnhancements = true;
  let pendingRemoval, undoItem, undoTimer, mutating = false;
  const rootPath = () => window.Shopify?.routes?.root || '/';
  const normalize = (value = '') => value.toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const context = (element) => {
    const root = element.closest('cart-drawer') || document.querySelector('cart-items') || document;
    try { return JSON.parse(root.querySelector('[data-wh-cart-context]')?.textContent || '{"lines":[]}'); } catch (_) { return { lines: [] }; }
  };
  const currentCodes = (cart) => [...new Set([
    ...(cart.discount_codes || []).filter((x) => x.applicable !== false).map((x) => x.code),
    ...(cart.cart_level_discount_applications || []).filter((x) => x.type === 'discount_code').map((x) => x.title),
    ...(cart.items || []).flatMap((x) => (x.line_level_discount_allocations || []).filter((a) => a.discount_application.type === 'discount_code').map((a) => a.discount_application.title))
  ])];
  const sectionTargets = () => {
    const result = [{ id: 'cart-drawer', target: 'cart-drawer .drawer__inner', source: '.drawer__inner' }, { id: 'cart-icon-bubble', target: '#cart-icon-bubble', source: '.shopify-section' }];
    for (const id of ['main-cart-items', 'main-cart-footer']) {
      const element = document.getElementById(id);
      if (element) result.push({ id: element.dataset.id, target: `#${id} .js-contents`, source: `#${id} .js-contents` });
    }
    if (document.getElementById('cart-live-region-text')) result.push({ id: 'cart-live-region-text', target: '#cart-live-region-text', source: '.shopify-section' });
    return result;
  };
  async function renderCart(state) {
    const targets = sectionTargets();
    let sections = state.sections;
    if (!sections || targets.some((item) => !sections[item.id])) {
      const url = new URL(rootPath() + 'cart', location.origin);
      url.searchParams.set('sections', targets.map((item) => item.id).join(','));
      const response = await fetch(url);
      if (!response.ok) throw new Error(window.whThemeText('wh_cart_refresh_error'));
      sections = await response.json();
    }
    for (const item of targets) {
      const html = new DOMParser().parseFromString(sections[item.id] || '', 'text/html');
      const incoming = html.querySelector(item.source), current = document.querySelector(item.target);
      if (incoming && current) current.innerHTML = incoming.innerHTML;
    }
    const empty = !document.querySelector('cart-drawer .cart-item');
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', empty);
    if (document.querySelector('cart-items')) {
      const pageEmpty = !document.querySelector('#main-cart-items .cart-item');
      document.querySelector('cart-items').classList.toggle('is-empty', pageEmpty);
      document.querySelector('#main-cart-footer')?.classList.toggle('is-empty', pageEmpty);
    }
    const drawer = document.querySelector('cart-drawer.active');
    if (drawer && typeof trapFocus === 'function') trapFocus(drawer.querySelector('.drawer__inner'), drawer.querySelector('.drawer__close'));
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
  }
  async function mutate(endpoint, payload) {
    if (mutating || window.whCartUpdating) throw new Error(window.whThemeText('wh_cart_wait'));
    mutating = true; window.whCartUpdating = true;
    document.querySelectorAll("#main-cart-items, #CartDrawer-CartItems").forEach(el => el.classList.add("cart__items--disabled"));
    document.querySelectorAll('.wh-cart-checkout').forEach((button) => { button.disabled = true; });
    try {
      const response = await fetch(rootPath() + `cart/${endpoint}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ ...payload, sections: sectionTargets().map((item) => item.id), sections_url: location.pathname })
      });
      const state = await response.json();
      if (!response.ok || state.status || state.errors) throw new Error(state.description || (typeof state.errors === 'string' ? state.errors : window.whThemeText('wh_cart_save_error')));
      try { await renderCart(state); }
      catch (_) {
        // The write already succeeded. Never offer an accidental duplicate addition.
        location.reload();
        return state;
      }
      return state;
    } finally {
      mutating = false; window.whCartUpdating = false;
      document.querySelectorAll("#main-cart-items, #CartDrawer-CartItems").forEach(el => el.classList.remove("cart__items--disabled"));
      document.querySelectorAll('.wh-cart-checkout').forEach((button) => { button.disabled = false; });
    }
  }
  function showUndo() { document.querySelectorAll('wh-cart-undo').forEach((element) => element.render()); }
  document.addEventListener('click', (event) => {
    const remove = event.target.closest('cart-remove-button');
    if (!remove) return;
    pendingRemoval = context(remove).lines[Number(remove.dataset.index) - 1];
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.matches('.quantity__input') && Number(event.target.value) === 0) pendingRemoval = context(event.target).lines[Number(event.target.dataset.index) - 1];
  }, true);
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (pendingRemoval && event.cartData?.items && !event.cartData.items.some((item) => item.key === pendingRemoval.key)) {
      undoItem = pendingRemoval; pendingRemoval = null;
      clearTimeout(undoTimer);
      undoTimer = setTimeout(() => { undoItem = null; showUndo(); }, 30000);
      showUndo();
    }
  });
  customElements.define('wh-cart-undo', class extends HTMLElement {
    connectedCallback() { this.render(); }
    render() {
      this.hidden = !undoItem;
      this.replaceChildren();
      if (!undoItem) return;
      const text = document.createElement('span'); text.textContent = window.whThemeText('wh_cart_removed'); text.setAttribute('role', 'status');
      const button = document.createElement('button'); button.type = 'button'; button.textContent = window.whThemeText('wh_cart_undo');
      button.addEventListener('click', async () => {
        const item = undoItem; if (!item) return;
        button.disabled = true; clearTimeout(undoTimer);
        try {
          const restore = { id: item.id, quantity: item.quantity, properties: Array.isArray(item.properties) ? Object.fromEntries(item.properties) : (item.properties || {}) };
          if (item.selling_plan) restore.selling_plan = item.selling_plan;
          await mutate('add', { items: [restore] }); undoItem = null; showUndo();
        } catch (error) { text.textContent = error.message; button.disabled = false; }
      });
      this.append(text, button);
    }
  });
  customElements.define('wh-cart-discount', class extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-apply-code]').addEventListener('click', () => this.apply());
      this.querySelector('input').addEventListener('keydown', (event) => { if (event.key === 'Enter') { event.preventDefault(); this.apply(); } });
      this.loadCodes();
    }
    async loadCodes() {
      try {
        const response = await fetch(rootPath() + 'cart.js');
        if (!response.ok || !this.isConnected) return;
        const cart = await response.json();
        this.codes = currentCodes(cart);
        this.querySelectorAll('.wh-cart-code').forEach((item) => item.remove());
        for (const code of this.codes) {
          const tag = document.createElement('div'); tag.className = 'wh-cart-code';
          const label = document.createElement('span'); label.textContent = code;
          const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.setAttribute('aria-label', window.whThemeText('wh_cart_remove_code', { code }));
          remove.addEventListener('click', () => this.apply(code)); tag.append(label, remove); this.append(tag);
        }
      } catch (_) { /* The checkout can still accept a discount code. */ }
    }
    async apply(removeCode) {
      const input = this.querySelector('input'), error = this.querySelector('[role="alert"]'), button = this.querySelector('[data-apply-code]');
      error.textContent = '';
      const code = input.value.trim();
      if (!removeCode && !code) { error.textContent = window.whThemeText('wh_cart_code_required'); input.focus(); return; }
      button.disabled = true;
      try {
        // Read current codes immediately before writing so another cart action cannot discard one.
        const response = await fetch(rootPath() + 'cart.js');
        if (!response.ok) throw new Error(window.whThemeText('wh_cart_code_error'));
        const existing = currentCodes(await response.json());
        const codes = removeCode ? existing.filter((x) => x.toLowerCase() !== removeCode.toLowerCase()) : [...new Set([...existing, code])];
        const scope = this.closest('cart-drawer') ? 'cart-drawer wh-cart-discount' : '#main-cart-footer wh-cart-discount';
        const state = await mutate('update', { discount: codes.join(',') });
        const target = document.querySelector(scope);
        if (!removeCode && !currentCodes(state).some((x) => x.toLowerCase() === code.toLowerCase())) {
          target.querySelector('details').open = true;
          target.querySelector('input').value = code;
          target.querySelector('[role="alert"]').textContent = window.whThemeText('wh_cart_code_invalid');
          target.querySelector('input').focus();
        }
      } catch (failure) { error.textContent = failure.message; } finally { button.disabled = false; }
    }
  });
  const kind = (type = '') => /aufkleber/.test(normalize(type)) ? 'sticker' : /warn|zaun|tur|haustur/.test(normalize(type)) ? 'home' : /saugnapf|magnet/.test(normalize(type)) ? 'car' : '';
  const anchor = (product) => {
    const breed = product.breeds?.[0];
    if (breed) return { query: breed, breed: normalize(breed) };
    const quote = product.title.match(/[„“"]([^„“"]+)[“"]/);
    if (quote) return { query: quote[1] };
    const words = product.title.split(/\s+/).filter((word) => !/^(schild|jagdschild|pferdeschild|autoschild|aufkleber|magnetschild|hundeschild|warnschild|pferdeaufkleber|hundeaufkleber|jagdaufkleber)$/i.test(word));
    return words[0]?.length > 3 ? { query: words[0] } : null;
  };
  const worlds = (product) => (product.tags || []).filter(tag => tag.startsWith('wh:world:'));
  const recommendationFormat = (product) => `${normalize(anchor(product)?.query || product.title)}:${kind(product.type) || normalize(product.type)}`;
  const selectRecommendations = (candidates) => {
    const formats = new Set();
    return [...candidates.values()].sort((a, b) => b.score - a.score || a.order - b.order).filter(candidate => {
      if (formats.has(candidate.format)) return false;
      formats.add(candidate.format); return true;
    }).slice(0, 2);
  };
  customElements.define('wh-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.request = new AbortController();
      document.addEventListener('cart:open', () => this.load(), { signal: this.request.signal });
      if (!this.closest('cart-drawer') || this.closest('cart-drawer').classList.contains('active')) this.load();
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-add-recommendation]'); if (!button) return;
        button.disabled = true; button.textContent = window.whThemeText('wh_cart_adding');
        try { await mutate('add', { items: [{ id: Number(button.dataset.addRecommendation), quantity: 1 }] }); }
        catch (error) { this.querySelector('[role="alert"]').textContent = error.message; button.disabled = false; button.textContent = window.whThemeText('wh_cart_add'); }
      }, { signal: this.request.signal });
    }
    async load() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const lines = context(this).lines, inCart = new Set(lines.map((item) => String(item.productId))), candidates = new Map();
      const ownedFormats = new Set(lines.map(recommendationFormat));
      const fetchCandidates = async (path, params) => {
        const url = new URL(rootPath() + path, location.origin);
        Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value));
        url.searchParams.set('section_id', 'wh-cart-recommendations');
        if (!['main', 'live'].includes(this.dataset.themeRole)) url.searchParams.set('preview_theme_id', this.dataset.themeId);
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Recommendations unavailable');
        return new DOMParser().parseFromString(await response.text(), 'text/html').querySelectorAll('[data-candidate]');
      };
      const remember = (item, score) => {
        const product = { title: item.dataset.title, type: item.dataset.type, breeds: JSON.parse(item.dataset.breeds || 'null') };
        const format = recommendationFormat(product);
        if (inCart.has(item.dataset.id) || ownedFormats.has(format)) return;
        if (!candidates.has(item.dataset.id) || candidates.get(item.dataset.id).score < score) {
          candidates.set(item.dataset.id, { item, score, format, order: candidates.size });
        }
      };
      // Search every distinct motif/breed, including later cart lines. A sign and its
      // sticker share one query, while already-owned formats are excluded as a group.
      const groups = new Map();
      for (const seed of lines) {
        const match = anchor(seed), seedKind = kind(seed.type);
        if (!match || !seedKind) continue;
        const key = normalize(match.query);
        if (!groups.has(key)) groups.set(key, { key, match, kinds: new Set(), worlds: new Set(), regions: new Set(), price: seed.price });
        const group = groups.get(key);
        group.kinds.add(seedKind); group.price = Math.max(group.price, seed.price);
        worlds(seed).forEach(world => group.worlds.add(world));
        (seed.regions || []).forEach(region => group.regions.add(normalize(region)));
      }
      let failed = false;
      const queries = [...groups.values()];
      for (let start = 0; start < queries.length; start += 3) {
        if (this.request.signal.aborted) break;
        const results = await Promise.allSettled(queries.slice(start, start + 3).map(async (group) => {
          const { match } = group;
          for (const item of await fetchCandidates('search', { q: match.query, type: 'product' })) {
            const candidateKind = kind(item.dataset.type);
            if (inCart.has(item.dataset.id) || !candidateKind || group.kinds.has(candidateKind)) continue;
            const candidateWorlds = worlds({ tags: JSON.parse(item.dataset.tags || '[]') });
            if (group.worlds.size && !candidateWorlds.some(world => group.worlds.has(world))) continue;
            const regions = JSON.parse(item.dataset.regions || 'null') || [];
            if (regions.length && !regions.some(region => group.regions.has(normalize(region)))) continue;
            const phrase = value => ` ${normalize(value).replace(/[^\p{L}\p{N}]+/gu, ' ').trim()} `;
            let breedMatch = false;
            try { breedMatch = (JSON.parse(item.dataset.breeds) || []).some((breed) => normalize(breed) === match.breed); } catch (_) {}
            if (match.breed ? !breedMatch : !phrase(item.dataset.title).includes(phrase(match.query))) continue;
            if (candidateKind === 'home' && !breedMatch) continue;
            const score = (breedMatch ? 350 : 300) + (candidateKind === 'sticker' ? 20 : 0) + (Number(item.dataset.price) <= group.price ? 10 : 0);
            remember(item, score);
          }
        }));
        failed ||= results.some(result => result.status === 'rejected');
      }
      // When no exact extra exists, use the cart's actual taxonomy instead of a
      // fixed collection or product list. Matching motifs still rank first.
      const considerRelated = (item, seeds, baseScore) => {
        const product = { title: item.dataset.title, type: item.dataset.type, tags: JSON.parse(item.dataset.tags || '[]'), breeds: JSON.parse(item.dataset.breeds || 'null') || [], regions: JSON.parse(item.dataset.regions || 'null') || [] };
        let score = 0;
        for (const seed of seeds) {
          const seedWorlds = worlds(seed), candidateWorlds = worlds(product);
          if (seedWorlds.length && !seedWorlds.some(world => candidateWorlds.includes(world))) continue;
          if (product.breeds.length && !seed.breeds?.some(breed => product.breeds.some(other => normalize(other) === normalize(breed)))) continue;
          if (product.regions.length && !seed.regions?.some(region => product.regions.some(other => normalize(other) === normalize(region)))) continue;
          const complementary = kind(seed.type) && kind(product.type) && kind(seed.type) !== kind(product.type);
          score = Math.max(score, baseScore + (complementary ? 40 : 0) + (kind(product.type) === 'sticker' ? 10 : 0) + (Number(item.dataset.price) <= seed.price ? 5 : 0));
        }
        if (score) remember(item, score);
      };
      if (selectRecommendations(candidates).length < 2) {
        const worldGroups = new Map();
        for (const seed of lines) for (const world of worlds(seed)) {
          if (!worldGroups.has(world)) worldGroups.set(world, []);
          worldGroups.get(world).push(seed);
        }
        const fallbackQueries = [...worldGroups].flatMap(([world, seeds]) => {
          const q = `tag:${JSON.stringify(world)}`;
          // A separate sticker query keeps lower-priced extras in reach even
          // when the first search page contains mostly signs.
          return [{ q, seeds }, ...(seeds.some(seed => kind(seed.type) !== 'sticker') ? [{ q: `${q} Aufkleber`, seeds }] : [])];
        });
        for (let start = 0; start < fallbackQueries.length && !this.request.signal.aborted; start += 3) {
          const results = await Promise.allSettled(fallbackQueries.slice(start, start + 3).map(async ({ q, seeds }) => {
            for (const item of await fetchCandidates('search', { q, type: 'product' })) considerRelated(item, seeds, 100);
          }));
          failed ||= results.some(result => result.status === 'rejected');
        }
      }
      // Native related products also cover future products without taxonomy tags.
      if (selectRecommendations(candidates).length < 2) {
        const seeds = [...new Map(lines.map(line => [line.productId, line])).values()];
        for (let start = 0; start < seeds.length && !this.request.signal.aborted; start += 3) {
          const results = await Promise.allSettled(seeds.slice(start, start + 3).map(async seed => {
            for (const item of await fetchCandidates('recommendations/products', { product_id: seed.productId, limit: 10, intent: 'related' })) considerRelated(item, [seed], 50);
          }));
          failed ||= results.some(result => result.status === 'rejected');
          if (selectRecommendations(candidates).length === 2) break;
        }
      }
      this.loading = false;
      if (!this.isConnected || this.request.signal.aborted) return;
      const chosen = selectRecommendations(candidates);
      this.querySelector('[data-recommendation-list]').replaceChildren(...chosen.map(candidate => candidate.item));
      this.hidden = !chosen.length;
      this.loaded = !failed;
    }
    disconnectedCallback() { this.request?.abort(); }
  });
})();
